import React from "react";
import Container from "@material-ui/core/Container";
import { makeStyles, styled } from "@material-ui/core/styles";
import { Chip, colors, Grid } from "@material-ui/core";
import { Done } from "@material-ui/icons";
import { CostType } from "../../../../../services/currencySalesProfit-services";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  chip: {
    paddingLeft: "10px",
    paddingRight: "10px",
    marginLeft: "10px",
  },
}));

const ListItem = styled("li")(({ theme }) => ({
  margin: theme.spacing(0.5),
}));

const SelectTypesFilter = (props) => {
  const { rptParams, setRptParams } = props;
  const classes = useStyles();
  const { t } = useTranslation(["forms"]);
  return (
    <Container
      style={{
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        listStyle: "none",
        padding: "10px",
        margin: "0px",
      }}
      component="ul"
    >
      
      {CostType.map((x) => {
        return (
          <ListItem key={x.id}>
            {x.id === rptParams.type_Cost.id ? (
              <Chip
                className={classes.chip}
                label={t(x.label)}
                icon={<Done />}
                style={{ backgroundColor: colors.green[300], color: "#fff" }}
                clickable
              />
            ) : (
              <Chip
                className={classes.chip}
                label={t(x.label)}
                variant="outlined"
                color={"green"}
                onClick={() => {
                  setRptParams({ ...rptParams, type_Cost: x });
                }}
              />
            )}
          </ListItem>
        );
      })}
    </Container>
  );
};

export default SelectTypesFilter;
